// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ParticipantOnboardingRequest } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Participant';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useParticipantOnboardingRequests: () => UseQueryResult<
  TemplateContract<ParticipantOnboardingRequest>[],
  string
> = () =>
  useOperatorBasedQuery('queryParticipantOnboardingRequests', (ledgerApi, offset, operator) =>
    ledgerApi.queryParticipantOnboardingRequests(offset, operator),
  );

export default useParticipantOnboardingRequests;
